import React, { FC } from 'react';
import LoaderImage from '@/assets/images/loader.svg';

const Loader: FC<{ className?: string; width?: string; children?: React.ReactNode; variant?: 'no-bg' | 'spinner-only' }> = ({
  className,
  width,
  children,
  variant,
}: {
  className?: string;
  width?: string;
  children?: React.ReactNode;
  variant?: 'no-bg' | 'spinner-only';
}) => {
  const variantClass = variant ? `loader-${variant}` : '';
  return (
    <div className={['loader', variantClass, className].filter(Boolean).join(' ')}>
      {children ? children : <img src={LoaderImage} alt="loader" width={width} />}
    </div>
  );
};
export default Loader;
